import { createContext } from 'react'

/**
 * Supplies the action behind the inactive-workflow-type tooltip's "Workflow
 * Configurator" link. Kept as a plain `() => void` so this shared selector stays
 * app-agnostic — it never references a desktop store or page. The desktop app
 * provides a concrete handler (navigate to the Workflow Configurator page); apps
 * that don't (mobile) leave it null and the tooltip renders plain text. A caller
 * can still override per-instance via the `onManageInConfigurator` prop.
 */
export const ManageWorkflowTypesContext = createContext<(() => void) | null>(
  null,
)
